import { createContext, useContext } from 'react';

import { DEFAULT_CHART_SIZE, METER_BAR_SIZE } from '../constants.js';
import { MeterBarSize } from '../types/meter-bars.js';

export type MeterBarLayoutSizeProps = {
  /**
   * The size that applies to the value, icon, and label.
   * @defaultvalue 'size16'
   */
  size: MeterBarSize;
  segmentHeight: number;
};

export const MeterBarLayoutSizeContext = createContext<MeterBarLayoutSizeProps>(
  {
    size: METER_BAR_SIZE.Size16,
    segmentHeight: DEFAULT_CHART_SIZE,
  },
);

export const useMeterBarLayoutSize = () =>
  useContext(MeterBarLayoutSizeContext);

useMeterBarLayoutSize['displayName'] = 'useMeterBarLayoutSize';
MeterBarLayoutSizeContext['displayName'] = 'MeterBarLayoutSizeContext';
